import { render, staticRenderFns } from "./SystemPrintConfig.vue?vue&type=template&id=b37567ec&scoped=true"
import script from "./SystemPrintConfig.vue?vue&type=script&lang=js"
export * from "./SystemPrintConfig.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b37567ec",
  null
  
)

export default component.exports